import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { clientSettings } from 'go-modules/models/common/client.settings';
import { Observable } from 'rxjs';
import type { OrgTypeResource } from '@go-modules/interfaces/org-type-resource';

@Injectable({
	providedIn: 'root'
})
export class OrgTypesService {
	constructor (
		private http: HttpClient
	) {}

	public getOrgTypes (): Observable<OrgTypeResource[]> {
		return this.http.get<OrgTypeResource[]>(`${clientSettings.GoReactV2API}/org-types`);
	}
}
